import React, { useEffect } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import useOnScreen from '../useOnScreen';
import brandList from '../assetsV2/brandsIndexNew';
import gameCovers from '../assetsV2/gamecover';

import anime from 'animejs';


import './HOurBrands.scss';

const HOurBrands = (props) => {
  const {
    pOffset,
    layoutFactor = 1,
    offsetAdjust = 0,
  } = props;
  const ref = React.createRef();
  const onScreen = useOnScreen(ref, '100px', 0.5);
  const [debounce, setDebounce] = React.useState(true);

  useEffect(() => {
    if (onScreen && debounce) {
      anime({
        targets: '.cascade-fade-h',
        opacity: [1, 0],
        translateY: 100,
        duration: 1000,
        direction: 'reverse',
        easing: 'linear',
        delay: anime.stagger(60, { direction: 'reverse' }),
      });
      setDebounce(false);
    }
  }, [onScreen, debounce]);

  return (
    <>
      <ParallaxLayer
        className="slide-h-container"
        factor={layoutFactor}
        offset={pOffset + offsetAdjust}
        speed={0}>
        <div>
          <div className="brand-title cascade-fade-h fade-up-prep">Brands we’ve worked with</div>
        </div>
        <div ref={ref} />

        <div className="brand-logo-scroll1 scroll-mask">
          <div className="scroll-inner left">
            {[...brandList, ...brandList].map((brand, i) => (
              <div className="brand-box" key={i}>
                <img src={brand} alt={brand} draggable="false"  loading="lazy"/>
              </div>
            ))}
          </div>
        </div>

        <div className="game-cover-scroll scroll-mask">
          <div className="scroll-inner right">
            {[...gameCovers, ...gameCovers].map((game, i) => (
              <div className="game-card-img-wrapper" key={i}>
                <img src={game} alt={game} className="game-card-img" draggable="false" loading="lazy"/>
                <img src={game} alt={game} className="game-card-img-reflection" draggable="false" loading="lazy"/>
              </div>
            ))}
          </div>
        </div>
      </ParallaxLayer>
    </>
  );
};

export default HOurBrands;
